import { render, staticRenderFns } from "./rewardLayout.vue?vue&type=template&id=bf9b407a&"
import script from "./rewardLayout.vue?vue&type=script&lang=js&"
export * from "./rewardLayout.vue?vue&type=script&lang=js&"
import style0 from "./rewardLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBadge,VBtn})
